import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export const useCancelProUpgrade = (
  options?: UseMutationOptions<any, Error, void>
) => {
  return useMutation({
    ...options,
    mutationKey: ["cancelProUpgrade"],
    mutationFn: async () => {
      return axiosInstance
        .put("/subscriptions/cancel-pro-upgrade")
        .then((res) => res.data);
    },
    onMutate: () => {
      Toast({
        message: "Ładowanie...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "cancel-pro-upgrade",
      });
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["subscriptions"] });
      queryClient.invalidateQueries({ queryKey: ["customers"] });
      queryClient.invalidateQueries({ queryKey: ["me"] });
      queryClient.invalidateQueries({ queryKey: ["payments"] });
      Toast({
        message: "Zmiana pakietu została anulowana.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "cancel-pro-upgrade",
      });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Wystąpił błąd podczas anulowania zmiany pakietu.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "cancel-pro-upgrade",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useCancelProUpgrade;
